import {mapStudyDbToType, type Study} from '@cp/model';
import {getDoc} from 'firebase/firestore';
import {getStudyDocRef} from './getStudyDocRef';

export default async function getStudyDoc(moduleId: string, topic: string): Promise<Study | undefined> {
  const ref = getStudyDocRef(moduleId, topic);
  const snapshot = await getDoc(ref);
  return mapStudyDbToType(snapshot);
}
